var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServiceProductadd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 19C13 18.4477 13.4477 18 14 18H34C34.5523 18 35 18.4477 35 19V33C35 34.1046 34.1046 35 33 35H15C13.8954 35 13 34.1046 13 33V19ZM19.3333 26.8334C19.3333 26.2811 19.7811 25.8334 20.3333 25.8334H23V23.0641C23 22.5119 23.4478 22.0641 24 22.0641C24.5523 22.0641 25 22.5119 25 23.0641V25.8334H27.6667C28.219 25.8334 28.6667 26.2811 28.6667 26.8334C28.6667 27.3856 28.219 27.8334 27.6667 27.8334H25V30.6026C25 31.1549 24.5523 31.6026 24 31.6026C23.4478 31.6026 23 31.1549 23 30.6026V27.8334H20.3333C19.7811 27.8334 19.3333 27.3856 19.3333 26.8334Z",
    fill: "#363A4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6 15.2C34.3688 15.7766 33.961 17 33 17L15 17C14.039 17 13.6312 15.7766 14.4 15.2L16.8 13.4C17.1462 13.1404 17.5673 13 18 13L30 13C30.4327 13 30.8538 13.1404 31.2 13.4L33.6 15.2Z",
    fill: "#363A4D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceProductadd);
export default __webpack_public_path__ + "static/media/service_productadd.c55d8ac45a4db7287d99e88e4b3b8b5d.svg";
export { ForwardRef as ReactComponent };